module.exports = __webpack_public_path__ + "img/ic_menu.ae57d006.svg";